import { render, staticRenderFns } from "./orgExamInfo.vue?vue&type=template&id=a4944600&scoped=true&"
import script from "./orgExamInfo.vue?vue&type=script&lang=js&"
export * from "./orgExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./orgExamInfo.vue?vue&type=style&index=0&id=a4944600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4944600",
  null
  
)

export default component.exports